'use strict';

module.exports = {
  addToCart: 'PROVIDER_ADD_TO_CART',
  refreshCart: 'PROVIDER_REFRESH_CART',
  updateCartItem: 'PROVIDER_UPDATE_CART_ITEM',
  clearCart: 'PROVIDER_CLEAR_CART',
  css: 'PROVIDER_CSS',
  sdkReady: 'PROVIDER_LOADED',
  goToCheckout: 'PROVIDER_GO_TO_CHECK_OUT',
  removeFromCart: 'PROVIDER_REMOVE_FROM_CART',
  backHome: 'PROVIDER_BACK_HOME',
  navigateToUrl: 'PROVIDER_NAVIGATE_TO_URL',
  setHeight: 'SET_HEIGHT',
  callback: 'PROVIDER_CALLBACK',
  selectPhoto: 'PROVIDER_SELECT_PHOTO',
  selectFile: 'PROVIDER_SELECT_FILE',
  close: 'PROVIDER_CLOSE',
  saveCompleted: 'PROVIDER_SAVE_COMPLETED',
  getSiteUrls: 'PROVIDER_GET_SITE_URLS',
  getSiteProperties: 'PROVIDER_GET_SITE_PROPERTIES',
  changeCheckoutState: 'PROVIDER_CHANGE_CHECKOUT_STATE',
  checkout: 'PROVIDER_CHECKOUT',
  save: 'PROVIDER_SAVE',
  openManege: 'PROVIDER_OPEN_MANAGE',
  openPricing: 'PROVIDER_OPEN_PRICING',
  setDefaultPrice: 'PROVIDER_SET_DEFAULT_PRICE',
  itemChanged: 'PROVIDER_ITEM_CHANGED',
  addToCartRequest: 'PROVIDER_ADD_TO_CART_REQUEST',
  openModal: 'PROVIDER_OPEN_MODAL',
  getCartItems: 'PROVIDER_GET_CART_ITEMS',
  getStyles: 'PROVIDER_GET_STYLES',
  setMobileProductData: 'PROVIDER_SET_MOBILE_INITIAL_DATA',
  mobileItemClicked: 'PROVIDER_MOBILE_ITEM_CLICKED',
  gotoPayments: 'PROVIDER_GOTO_PAYMENTS'
};